import Hero from '../components/sections/Hero';
import BookingSection from '../components/sections/BookingSection';
import ServicesSection from '../components/sections/ServicesSection';
import GallerySection from '../components/sections/GallerySection';
import ContactSection from '../components/sections/ContactSection';
import Reveal from '../components/ui/Reveal';

function Home({ language }) {
  return (
    <>
      <Hero language={language} />
      <BookingSection language={language} />
      <ServicesSection language={language} />
      <GallerySection language={language} />

      <Reveal>
        <ContactSection language={language} />
      </Reveal>
    </>
  );
}

export default Home;
